import * as React from 'react'
import { ReactElement, useEffect } from 'react'
import FileForm, { FileFormType } from '../../components/Form/File/FileForm'
import { FileMutationDto } from '../../config/fileConfig'
import { useParams } from 'react-router-dom'
import Loading from '../../components/Loading'
import useEntity from '../../hooks/useEntity'
import useAxios from '../../hooks/useAxios'
import { EntityParams } from '../../components/Form/Form'
import useUnits from '../../hooks/useUnits'
import { ModulesConstants } from '../../components/Form/File/ModulePivotItem'
import { useSettings } from '../../hooks/useSettings'
import useModules from '../../hooks/module/useModules'
import useUsers from '../../hooks/useUsers'
import { sortTiers } from '../../components/Form/Tier/TierList'

export default function EditFile(): ReactElement {
    const axios = useAxios()
    const users = useUsers()

    const { id } = useParams<EntityParams>()
    const { activeUnits } = useUnits()
    const modules = useModules()
    const settings = useSettings()
    const [entity] = useEntity<FileMutationDto>(
        (id: string) => ({ url: `/file/${id}/edit` }),
        id,
        response => ({
            ...response.data,
            tiers: sortTiers(users, response.data.tiers),
        }),
    )
    useEffect(() => {
        if (entity.data) {
            //Apply onAfterChecked for existing file modules.
            if (entity.data.modules && entity.data.modules.length > 0) {
                entity.data.modules.forEach(module =>
                    ModulesConstants.get(module.type)?.onAfterChecked?.(entity.data, settings),
                )
            }

            //Apply onAfterChecked for modules which are global modules.
            modules?.modules
                ?.filter(module => !module.fileModule)
                .forEach(module => ModulesConstants.get(module.type)?.onAfterChecked?.(entity.data, settings))
        }
    }, [entity.data])

    if (!entity.loaded) {
        return <Loading />
    }

    return (
        <FileForm
            id={id}
            formType={FileFormType.Edit}
            formikProps={{
                initialValues: {
                    unit: activeUnits.length === 1 ? activeUnits[0].key : undefined,
                    ...entity.data,
                },
            }}
            onSubmit={(file: FileMutationDto) => axios.put<string>(`/file/${id}`, file)}
        />
    )
}
